import { Grid, Box, Skeleton } from "@mui/material";

export const SkeletonDetalhePublico = () => (
  <Grid container spacing={2}>
    <Grid container size={{xs: 12, md: 4}} spacing={2} alignSelf="flex-start">
      <Grid size={{xs:12}}>
        <Box sx={{ p: 2, borderRadius: 1, bgcolor: 'background.paper' }}>
          <Skeleton variant="text" width="60%" height={40} />
          <Skeleton variant="rectangular" height={100} sx={{ mt: 2, borderRadius: 1 }} />
          <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
            <Skeleton variant="rectangular" width="100%" height={80} sx={{ borderRadius: 1 }} />
            <Skeleton variant="rectangular" width="100%" height={80} sx={{ borderRadius: 1 }} />
          </Box>
        </Box>
      </Grid>
      
      <Grid size={{xs:12}}>
        <Box sx={{ p: 2, borderRadius: 1, bgcolor: 'background.paper' }}>
          <Skeleton variant="text" width="40%" height={30} />
          <Skeleton variant="rectangular" height={150} sx={{ mt: 1, borderRadius: 1 }} />
        </Box>
      </Grid>
      
      <Grid size={{xs:12}}>
        <Box sx={{ p: 2, borderRadius: 1, bgcolor: 'background.paper' }}>
          <Skeleton variant="text" width="50%" height={30} />
          <Skeleton variant="rectangular" height={200} sx={{ mt: 1, borderRadius: 1 }} />
        </Box>
      </Grid>
    </Grid>

    <Grid container size={{xs: 12, md: 8}} spacing={2} alignSelf="flex-start">
      {/* Card Dados Gerais */}
      <Grid size={{xs:12}}>
        <Box sx={{ p: 2, borderRadius: 1, bgcolor: 'background.paper' }}>
          <Skeleton variant="text" width="40%" height={35} sx={{ mb: 2 }} />
          <Grid container spacing={2}>
            {[...Array(6)].map((_, index) => (
              <Grid size={{xs:12, sm: 6}} key={index}>
                <Skeleton variant="text" width="30%" height={25} />
                <Skeleton variant="rectangular" height={40} sx={{ mt: 0.5, borderRadius: 1 }} />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Grid>

      {[...Array(3)].map((_, index) => (
        <Grid size={{xs:12}} key={`fornecedor-${index}`}>
          <Box sx={{ p: 2, borderRadius: 1, bgcolor: 'background.paper' }}>
            <Skeleton variant="text" width="50%" height={30} />
            <Skeleton variant="rectangular" height={100} sx={{ mt: 1, borderRadius: 1 }} />
          </Box>
        </Grid>
      ))}
    </Grid>
  </Grid>
);
